import { useContext } from 'react';
import AnimateHeight from '@/common/AnimateHeight';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import { CommonWrapper } from './FiltersMenu.styles';

export default function BedLength() {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();

  const show = Boolean(
    facetData.truckBedLengths?.buckets &&
      facetData.truckBedLengths?.buckets?.length > 0
  );

  return (
    <AnimateHeight show={show}>
      <FilterDrawer
        testId="facet-bed-length"
        facetContent={facetData.truckBedLengths?.buckets}
        facetName="Bed Length"
      >
        <CommonWrapper>
          {facetData.truckBedLengths?.buckets?.map(
            ({ count, displayName, key }) => (
              <Checkbox
                facet="truckBedLengths"
                filter={key}
                id={`bed-length-${displayName}`}
                key={displayName}
                label={
                  showInventoryCounts
                    ? `${displayName} (${count.toLocaleString()})`
                    : displayName
                }
                checked={appliedFilters?.truckBedLengths?.some(
                  length => length === key
                )}
                onChange={() =>
                  updateListFilter({
                    filterKey: 'truckBedLengths',
                    value: key
                  })
                }
              />
            )
          )}
        </CommonWrapper>
      </FilterDrawer>
    </AnimateHeight>
  );
}
